<template>
  <form role="form">
    <div class="row">
      <div class="col-md-9">
        <base-input
          class="input-group-alternative mb-3"
          :placeholder="`${orgType} Join Code`"
          addon-left-icon="fas fa-key"
          v-model="orgCode"
          :disabled="loadingEnrollFuncRes === true"
        />
      </div>
      <div class="col-md-3">
        <base-button type="primary" @click="submit()" :disabled="loadingEnrollFuncRes === true">
          <div v-if="!loadingEnrollFuncRes">Submit</div>
          <div v-else>Loading...</div>
        </base-button>
      </div>
    </div>
    <a v-if="orgType === 'Employer'" class="h3 text-gray" style="cursor: pointer;" data-toggle="modal"
              data-target="#newEmployer">
      Click here to enroll as a new employer
    </a>
    <div class="form-group mb-3" v-bind:class="{ 'd-none': !hasError }">
      <small class="text-danger">{{errorMsg}}</small>
    </div>

    <modal id="newEmployer" title="New Employer">
      <new-employer-form/>
    </modal>
  </form>
</template>

<script>
import firebase from "@/config/firebase.js";
import NewEmployerForm from "@/views/dashboard/components/NewEmployerForm.vue";

import Modal from "@/components/Modal.vue";

export default {
  name: "joinorggetstarted",
  props: {
    orgType: String
  },
  components: {
    "new-employer-form": NewEmployerForm,
    modal: Modal
  },
  data() {
    return {
      orgCode: "",
      hasError: false,
      errorMsg: "",
      loadingEnrollFuncRes: false
    };
  },
  methods: {
    submit() {
      const self = this;

      self.loadingEnrollFuncRes = true;

      const user = firebase.auth().currentUser;

      const name = user.displayName;
      const email = user.email;
      const userId = user.uid;

      if (self.orgCode != "") {
        firebase
          .firestore()
          .doc("organizations/" + self.orgCode)
          .get()
          .then(function(orgDoc) {
            const orgData = orgDoc.data();

            if (!orgData) {
              self.hasError = true;
              self.errorMsg = `Invalid ${self.orgType} Code`;

              self.loadingEnrollFuncRes = false;
            } else {
              const orgId = self.orgCode;

              firebase
                .firestore()
                .doc("organizations/" + orgId + "/pendingUsers/" + userId)
                .set({
                  name: name,
                  email: email
                })
                .then(() => {
                  firebase
                    .firestore()
                    .doc("users/" + userId)
                    .set({
                      pendingOrg: orgId
                    });
                })
                .then(() => {
                  location.reload();
                });
            }
          });
      } else {
        self.hasError = true;
        self.errorMsg = `Please enter a ${self.orgType} Code`;

        self.loadingEnrollFuncRes = false;
      }
    }
  }
};
</script>

<style scoped>
</style>
